import React, {memo} from 'react';
import {BaseSettingsScreenBase, Page} from '../BaseSettingsScreen';

import iconDevices from '../../../assets/images/icons/settings/devices.png';
import {useDispatch} from "react-redux";
import {backButtonToggle} from "../../../store/ui/actions";

const getPages = (gatewayId: string): Page[] => [
    {
        icon: iconDevices,
        title: 'uart',
        requiredRole: 'developer',
        routerLink: '/uart',
    },
    {
        icon: iconDevices,
        title: 'door_brands',
        requiredRole: 'developer',
        routerLink: '/door-brand',
    },
    {
        icon: iconDevices,
        title: 'control_types',
        requiredRole: 'developer',
        routerLink: '/control-type',
    },
    {
        icon: iconDevices,
        title: 'device_types',
        requiredRole: 'developer',
        routerLink: '/bridge-device-type',
    },
    {
        icon: iconDevices,
        title: 'input_types',
        requiredRole: 'developer',
        routerLink: '/input-type',
    },
    {
        icon: iconDevices,
        title: 'camera_brands',
        requiredRole: 'developer',
        routerLink: '/camera-brand',
    },
    {
        icon: iconDevices,
        title: 'push_token',
        requiredRole: 'developer',
        routerLink: '/users/edit-push-token',
    },
    {
        icon: iconDevices,
        title: 'test_2',
        requiredRole: 'developer',
        routerLink: '/test',
    },
];

export const DeveloperSettingsScreen = memo(function DeveloperSettingsScreen() {
    const dispatch = useDispatch();
    dispatch(backButtonToggle({is_open: true, to: '/'}));
    return (
        <BaseSettingsScreenBase
            baseRoute={'/developer'}
            getPages={getPages}/>
    );
});
